export enum LogLevel {
  Information,
  Warning,
  Error,
  Fatal
}

export default LogLevel
